import Big from 'big.js'

export const defractionize = (num: number) => {
  return Big(num).times(100).round().toNumber()
}

export const fractionize = (num: number) => {
  return Big(num).div(100).toNumber()
}
